import { createRouter, createWebHistory } from "vue-router";
import checkSessionAdmin from "@/js/checkSessionAdmin";
//import checkSession from "@/js/checkSession.js";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
    alias: ["/home", "/home/"],
  },
  //로그인
  {
    path: "/login",
    name: "login",
    component: () => import("../views/auth/ULogin.vue"),
  },
  //회원가입
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/auth/TermsView.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/auth/SignUp.vue"),
  },

  //아이디/비밀번호 찾기
  {
    path: "/find",
    name: "find",
    component: () => import("../views/auth/FindView.vue"),
  },

  //사용자 마이페이지 - 회원 비밀번호 확인
  {
    path: "/mypage",
    name: "mypage",
    component: () => import("../views/user/MyPage.vue"),
  },
  {
    path: "/mypageInfo",
    name: "mypageInfo",
    component: () => import("../views/user/MyPageInfo.vue"),
  },

  //관리자 페이지
  {
    path: "/alogin",
    name: "alogin",
    component: () => import("../views/admin/ALogin.vue"),
  },
  {
    path: "/admin/usersignup",
    name: "usersignup",
    component: () => import("../views/admin/user/UserSignUp.vue"),
  },
  {
    path: "/admin/usermgmt",
    name: "usermgmt",
    component: () => import("../views/admin/user/UserMgmt.vue"),
  },
  {
    path: "/admin/usermgmtdetail/:id",
    name: "usermgmtdetail",
    component: () => import("../views/admin/user/UserMgmtDetail.vue"),
    props: true,
  },
  {
    path: "/admin/commumgmt",
    name: "commumgmt",
    component: () => import("../views/admin/community/CommuMgmt.vue"),
  },
  {
    path: "/admin/deletedcommulist",
    name: "deletedcommulist",
    component: () => import("../views/admin/community/DCommuMgmt.vue"),
  },
  {
    path: "/admin/commuboardmgmt/:id",
    name: "commuboardmgmt",
    component: () => import("../views/admin/community/CommuBoardMgmt.vue"),
    props: true,
  },
  {
    path: "/admin/acommuboarddetail/:id/:curboardidx",
    name: "acommuboarddetail",
    component: () => import("../views/admin/community/ACommuBoardDetail.vue"),
    props: true,
  },
  {
    path: "/admin/acommuboardswrite/:curboard",
    name: "acommuboardswrite",
    component: () => import("../views/admin/community/ACommuBoardWrite.vue"),
    props: true,
  },
  {
    path: "/admin/acommuboardsedit/:id/:curboard",
    name: "acommuboardsedit",
    component: () => import("../views/admin/community/ACommuBoardEdit.vue"),
    props: true,
  },

  {
    path: "/admin/boardmgmt",
    name: "boardmgmt",
    component: () => import("../views/admin/board/BoardMgmt.vue"),
  },
  {
    path: "/admin/boardmgmtwrite/:curboard",
    name: "boardmgmtwrite",
    component: () => import("../views/admin/board/BoardMgmtWrite.vue"),
  },
  {
    path: "/admin/boardmgmtedit/:id/:curboardidx",
    name: "boardmgmtedit",
    component: () => import("../views/admin/board/BoardMgmtEdit.vue"),
  },
  {
    path: "/admin/boardmgmtview/:id/:curboardidx",
    name: "boardmgmtview",
    component: () => import("../views/admin/board/BoardMgmtView.vue"),
  },
  {
    path: "/admin/boardmgmtlist/:id",
    name: "boardmgmtlist",
    component: () => import("../views/admin/board/BoardMgmtList.vue"),
    props: true,
  },
  {
    path: "/admin/addboard",
    name: "addboardmgmt",
    component: () => import("../views/admin/board/AddBoard.vue"),
  },
  {
    path: "/admin/boardusermgmt/:id",
    name: "boardusermgmt",
    component: () => import("../views/admin/board/BoardUserMgmt.vue"),
    props: true,
  },
  {
    path: "/admin/addboarduser/:id",
    name: "addboarduser",
    component: () => import("../views/admin/board/AddBoardUser.vue"),
    props: true,
  },
  {
    path: "/admin/inquirymgmt",
    name: "inquirymgmt",
    component: () => import("../views/admin/inquiry/InquiryMgmt.vue"),
  },
  {
    path: "/admin/inquirymgmtdetail/:id",
    name: "inquirymgmtdetail",
    component: () => import("../views/admin/inquiry/InquiryMgmtDetail.vue"),
    props: true,
  },
  {
    path: "/admin/consultingmgmt",
    name: "consultingmgmt",
    component: () => import("../views/admin/consulting/ConsultingMgmt.vue"),
  },
  {
    path: "/admin/consultingmgmtdetail/:id",
    name: "consultingmgmtdetail",
    component: () =>
      import("../views/admin/consulting/ConsultingMgmtDetail.vue"),
    props: true,
  },
  {
    path: "/admin/chatmgmt",
    name: "chatmgmt",
    component: () => import("../views/admin/chat/ChatMgmt.vue"),
  },

  //소개 메뉴
  {
    path: "/introduction/newbuddhanetwork",
    name: "about",
    component: () => import("../views/introduction/NewBuddhaNetwork.vue"),
  },
  {
    path: "/introduction/people",
    name: "people",
    component: () => import("../views/introduction/PeopleView.vue"),
  },
  {
    path: "/introduction/inquiry",
    name: "inquiry",
    component: () => import("../views/introduction/InquiryView.vue"),
  },
  {
    path: "/introduction/contact",
    name: "contact",
    component: () => import("../views/introduction/ContactView.vue"),
  },

  //활동, 공지, 자료실 메뉴
  {
    path: "/activity/:id",
    name: "activity",
    component: () => import("../views/board/ActivityBoard.vue"),
    props: true,
  },
  {
    path: "/news/:id",
    name: "notice",
    component: () => import("../views/board/NoticeBoard.vue"),
    props: true,
  },
  {
    path: "/thumbnews/:id",
    name: "thumbnailBoard",
    component: () => import("../views/board/ThumbnailBoard.vue"),
    props: true,
  },
  {
    path: "/news/:id/:curboardidx",
    name: "boardDetail",
    component: () => import("../views/board/BoardDetail.vue"),
    props: true,
  },
  {
    path: "/boardwrite/:curboard",
    name: "boardwrite",
    component: () => import("../views/board/BoardWrite.vue"),
  },

  //소모임 메뉴
  {
    path: "/community/allcommuboards",
    name: "allcommuboards",
    component: () => import("../views/community/AllCommuBorad.vue"),
    props: true,
  },
  {
    path: "/community/communityboards/:id",
    name: "communityboards",
    component: () => import("../views/community/CommunityBoards.vue"),
    props: true,
  },
  {
    path: "/community/communityboardswrite/:curboard",
    name: "communityboardswrite",
    component: () => import("../views/community/CommuBoardWrite.vue"),
    props: true,
  },
  {
    path: "/community/:id/:curboardidx",
    name: "communitydetail",
    component: () => import("../views/community/CommuBoardDetail.vue"),
    props: true,
  },
  {
    path: "/community/communityboardsedit/:id/:curboard",
    name: "communityboardsedit",
    component: () => import("../views/community/CommuBoardEdit.vue"),
    props: true,
  },

  //상담 메뉴
  {
    path: "/counseling/onlineCounselingGuide",
    name: "onlineCounselingGuide",
    component: () => import("../views/counseling/OnlineCounselingGuide.vue"),
  },
  {
    path: "/counseling/chatRoom",
    name: "chatRoom",
    component: () => import("../views/counseling/chatBoard/ChatRoom.vue"),
  },
  {
    path: "/counseling/chatRoom/:id",
    name: "chatRoomDetail",
    component: () => import("../views/counseling/chatBoard/ChatRoomDetail.vue"),
    props: true,
  },
  {
    path: "/counseling/counselingRoom",
    name: "counselingRoom",
    component: () =>
      import("../views/counseling/counselBoard/CounselingRoom.vue"),
  },
  {
    path: "/counseling/counselingRoomDetail/:id",
    name: "counselingDetail",
    component: () =>
      import("../views/counseling/counselBoard/CounselingDetail.vue"),
    props: true,
  },
  {
    path: "/counseling/write",
    name: "counselingWrite",
    component: () =>
      import("../views/counseling/counselBoard/CounselingWrite.vue"),
  },
  {
    path: "/counseling/memberBoard",
    name: "memberBoard",
    component: () => import("../views/counseling/memberBoard/MemberBoard.vue"),
  },
  {
    path: "/counseling/memberBoardWrite",
    name: "memberBoardWrite",
    component: () =>
      import("../views/counseling/memberBoard/MemberBoardWrite.vue"),
  },
  {
    path: "/counseling/memberBoardDetail/:id",
    name: "memberBoardDetail",
    component: () =>
      import("../views/counseling/memberBoard/MemberBoardDetail.vue"),
    props: true,
  },
  {
    path: "/counseling/memberBoardEdit/:id",
    name: "memberBoardEdit",
    component: () =>
      import("../views/counseling/memberBoard/MemberBoardEdit.vue"),
    props: true,
  },
  //후원 메뉴
  {
    path: "/support/donationGuide",
    name: "donationGuide",
    component: () => import("../views/support/DonationGuide.vue"),
  },

  //게시판 작성
  {
    path: "/noticeBoardWrite",
    name: "noticeBoardWrite",
    component: () => import("../components/NoticeBoardWrite.vue"),
  },
  {
    path: "/admin/etcmgmt",
    name: "etcmgmt",
    component: () => import("../views/admin/etc/EtcMgmt.vue"),
  },
  {
    path: "/admin/logmgmt",
    name: "logmgmt",
    component: () => import("../views/admin/etc/LogMgmt.vue"),
  },
  {
    path: "/admin/logdetail/:date",
    name: "logdetail",
    component: () => import("../views/admin/etc/LogDetail.vue"),
  },
];

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
//   scrollBehavior(to, from, savedPosition) {
//     if (savedPosition) {
//       return savedPosition; // 이전에 저장된 위치로 스크롤 (브라우저 뒤로가기)
//     } else {
//       return { top: 0 }; // 페이지 전환 시 스크롤 맨 위로
//     }
//   },
// });

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
// });

// router.afterEach(() => {
//   setTimeout(() => {
//     const containers = document.querySelectorAll(
//       ".u-content-container, .a-content-container"
//     );
//     containers.forEach((container) => {
//       container.scrollTo({ top: 0, left: 0 });
//     });
//   }, 50);
// });

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 이전에 저장된 위치로 스크롤 (브라우저 뒤로가기)
    } else {
      return { top: 0 }; // 페이지 전환 시 스크롤 맨 위로
    }
  },
});

router.beforeEach(async (to, from, next) => {
  // 로그인 여부 확인 (Vuex에서 관리하는 isAdmin 상태)
  //const isLoggedIn = sessionStorage.getItem("utype") === "99"; // true면 로그인 상태
  const isAdmin = await checkSessionAdmin.checkAdmin(); // 로그인 여부 확인
  // 관리 페이지 접근 시 로그인 확인
  if (to.path.indexOf("/admin") == 0 && !isAdmin) {
    sessionStorage.setItem("userData", {});
    sessionStorage.setItem("utype", -1); // utype 저장
    // this.setAdmin(false);
    alert("관리자 페이지 로그인이 필요합니다."); // 관리자 페이지 로그인이 필요하다는 알림 표시
    next({ name: "alogin" }); // 로그인 페이지로 리다이렉트
  } else if (isAdmin && to.path === "/alogin") {
    // 로그인 상태일 때 /alogin으로 접근하려는 경우 자동으로 /admin으로 리다이렉트
    next({ path: "/admin" });
  } else {
    next(); // 로그인 상태이거나 관리 페이지가 아닌 페이지라면 이동 허용
  }

  // // 로그인 여부 확인 (Vuex에서 관리하는 isAdmin 상태)
  // //const isLoggedIn = sessionStorage.getItem("utype") === "99"; // true면 로그인 상태
  // const isLoggedIn = await checkSessionAdmin.checkAdmin(); // 로그인 여부 확인
  // // 관리 페이지 접근 시 로그인 확인
  // if (adminPaths.includes(to.path) && !isLoggedIn) {
  //   // 관리 페이지에 접근하려는데 로그인 안 된 경우
  //   if (from.name !== "alogin") {
  //     // "alogin" 페이지에서 온 것이 아니라면
  //     sessionStorage.setItem("userData", {});
  //     sessionStorage.setItem("utype", -1); // utype 저장
  //     // this.setAdmin(false);
  //     alert("관리자 로그인이 필요합니다."); // 관리자 로그인이 필요하다는 알림 표시
  //   }
  //   next({ name: "alogin" }); // 로그인 페이지로 리다이렉트
  // } else if (isLoggedIn && to.path === "/alogin") {
  //   // 로그인 상태일 때 /alogin으로 접근하려는 경우 자동으로 /admin으로 리다이렉트
  //   next({ path: "/admin" });
  // } else {
  //   next(); // 로그인 상태이거나 관리 페이지가 아닌 페이지라면 이동 허용
  // }
});

export default router;
